import React from 'react';

const Features = () => {
  return (
    <section className="py-16 md:py-24 overflow-x-clip bg-gradient-to-b from-zinc-50 to-white">
      <div className="max-w-screen-xl w-full mx-auto px-6 lg:px-16">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 items-center gap-x-16 mb-8 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Key Features of <span className="relative whitespace-nowrap text-yellow-500">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 249 22" fill="currentColor" className="absolute inset-x-0 -bottom-0.5 fill-blue-400/75">
                <path d="M247.564 18.5808C241.772 13.3568 232.473 12.7526 225.225 11.4427C217.124 9.97398 208.996 8.57034 200.846 7.46096C186.542 5.51305 172.169 4.08857 157.79 3.01565C126.033 0.645858 94.0929 0.0338786 62.3387 2.36982C42.1785 3.85419 22.008 5.90888 2.32917 10.8464C-0.0155171 11.4349 0.207047 14.6719 2.6889 14.7084C22.0261 14.9896 41.3866 12.6406 60.7109 11.8568C79.9471 11.0808 99.2274 10.6719 118.484 10.9558C142.604 11.3125 166.719 12.8334 190.722 15.5156C199.956 16.5469 209.195 17.6016 218.411 18.8255C227.864 20.0808 237.259 22 246.767 20.7422C247.709 20.6198 248.426 19.3568 247.564 18.5808Z"></path>
              </svg>
              <span className="z-10 relative">intelleX</span>
            </span> CLMS
          </h2>
          <p className="text-lg text-zinc-700 w-full md:w-5/6 leading-8">
            Explore the core features designed to make your contract management effective and efficient.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 md:mb-20">
          {/* Feature 1 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2H5a2 2 0 0 1 -2 -2V5z"></path>
                <path d="M7 2v2"></path>
                <path d="M7 10h10"></path>
                <path d="M7 14h10"></path>
                <path d="M7 18h10"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Contract Creation</h3>
              <p className="text-base text-zinc-500">Create contracts effortlessly with customizable templates and automated workflows.</p>
            </div>
          </div>
          {/* Feature 2 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 6v6l4 2"></path>
                <path d="M21 12v6a2 2 0 0 1 -2 2h-4"></path>
                <path d="M3 12v6a2 2 0 0 1 2 2h4"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Contract Search</h3>
              <p className="text-base text-zinc-500">Locate contracts quickly using advanced search capabilities and filters.</p>
            </div>
          </div>
          {/* Feature 3 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16v16H4z"></path>
                <path d="M10 10l4 4m0 -4l-4 4"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Analytics & Reporting</h3>
              <p className="text-base text-zinc-500">Access in-depth analytics and reporting tools to track performance.</p>
            </div>
          </div>
          {/* Feature 4 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12l2 2l4 -4l2 2l6 -6"></path>
                <path d="M12 3v9a4 4 0 0 0 4 4h9"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Contract Management</h3>
              <p className="text-base text-zinc-500">Manage all stages of the contract lifecycle within a single platform.</p>
            </div>
          </div>
          {/* Feature 5 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 21l-6 -6"></path>
                <path d="M15 21l-6 -6"></path>
                <path d="M3 12a9 9 0 1 1 18 0a9 9 0 0 1 -18 0"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Compliance & Security</h3>
              <p className="text-base text-zinc-500">Maintain compliance with industry standards and ensure secure contract handling.</p>
            </div>
          </div>
          {/* Feature 6 */}
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-zinc-800 text-white p-2 w-12 h-12 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16v16H4z"></path>
                <path d="M4 4v16h16V4H4z"></path>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl leading-none mb-2 font-bold text-zinc-800">Customizable Settings</h3>
              <p className="text-base text-zinc-500">Adjust settings to fit your organization's needs and preferences.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
